/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { IPdfViewerProps, PdfViewer } from './pdfViewer';
import * as S from './styles';

export type IPdfViewerModalProps = {
  showModal: boolean;
} & IPdfViewerProps;

export const PdfViewerModal = ({
  showModal,
  onPdfClose,
  ...rest
}: IPdfViewerModalProps) => {
  return (
    <Modal
      show={showModal}
      size={'lg'}
      // fullscreen={true}
      style={S.ModalStyle}
      onHide={onPdfClose}
      scrollable={true}
      backdrop={true}
      // appElement={typeof window !== 'undefined' ? window.document.body : undefined}
    >
      <Modal.Header closeButton>{rest?.title}</Modal.Header>
      <Modal.Body>
        <PdfViewer {...rest} />
      </Modal.Body>
    </Modal>
  );
};

PdfViewerModal.defaultProps = {
  showModal: false,
};
